var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.46192C0 3.90963 0.447715 3.46191 1 3.46191C1.55228 3.46191 2 3.90963 2 4.46191V14.0004C2 14.5527 1.55228 15.0004 1 15.0004C0.447715 15.0004 0 14.5527 0 14.0004V4.46192Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1C5 0.447715 5.44772 0 6 0C6.55228 0 7 0.447715 7 1V14C7 14.5523 6.55228 15 6 15C5.44772 15 5 14.5523 5 14V1Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.61523C10 5.06295 10.4477 4.61523 11 4.61523C11.5523 4.61523 12 5.06295 12 5.61523V13.9999C12 14.5521 11.5523 14.9999 11 14.9999C10.4477 14.9999 10 14.5521 10 13.9999V5.61523Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.30762C15 2.75533 15.4477 2.30762 16 2.30762C16.5523 2.30762 17 2.75533 17 3.30762V13.9999C17 14.5522 16.5523 14.9999 16 14.9999C15.4477 14.9999 15 14.5522 15 13.9999V3.30762Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatistics);
export default __webpack_public_path__ + "static/media/menu-statistics.342e36232aabb055a453c3f97161cc22.svg";
export { ForwardRef as ReactComponent };